module.exports = __webpack_public_path__ + "img/smiley-athumbsup.8aec4e6d.gif";